<template>
    <div>
        <!-- Label Maker Table Start -->
        <div class="row">
            <div class="col-lg-2 offset-lg-10 col-md-4 offset-md-8 col-12">
                <MultiSelect 
                    v-model="filter.sumLabelCahaya.year"
                    :options="options.year"
                    :deselect-label="''"
                    :allowEmpty="false"
                    placeholder="All Years"
                    class="elegant-multiselect"
                />
            </div>
        </div>
        <div class="bg-white shadow box-content mt-3 mb-5">
            <div class="row">
                <div class="col-md-12">
                    <h4 class="text-center">Label Maker</h4>
                </div> 
            </div>
            <!-- <div class="row">
                <div class="col-md-6">
                    <h4 class="text-center">Cahaya</h4>
                </div>
                <div class="col-md-6">
                    <h4 class="text-center">Menara</h4>
                </div>
            </div> -->
            <div class="row">
                <div class="col-md-12">
                    <div>
                        <sumLabelCahaya
                            :data="data.sumLabelCahaya"
                            v-if='data.sumLabelCahaya'
                        ></sumLabelCahaya>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <!-- Label Maker Table End -->

        <!-- Oil Maker Table Start -->
        <div class="row">
            <div class="col-lg-2 offset-lg-10 col-md-4 offset-md-8 col-12">
                <MultiSelect 
                    v-model="filter.sumOilMaker.year"
                    :options="options.year"
                    :deselect-label="''"
                    :allowEmpty="false"
                    placeholder="All Years"
                    class="elegant-multiselect"
                />
            </div>
        </div>
        <div class="bg-white shadow box-content mt-3 mb-5">
            <div class="row">
                <div class="col-md-12">
                    <h4 class="text-center">Oil Maker</h4>
                </div> 
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div>
                        <sumOilMaker
                            :data="data.sumOilMaker"
                            v-if='data.sumOilMaker'
                        ></sumOilMaker>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <!-- Oil Maker Table End -->

        <!-- Customer Scan Table Start -->
        <div class="row">
            <div class="col-lg-2 offset-lg-10 col-md-4 offset-md-8 col-12">
                <MultiSelect 
                    v-model="filter.sumCustomer.year"
                    :options="options.year"
                    :deselect-label="''"
                    :allowEmpty="false"
                    placeholder="All Years"
                    class="elegant-multiselect"
                />
            </div>
        </div>
        <div class="bg-white shadow box-content mt-3 mb-5">
            <div class="row">
                <div class="col-md-12">
                    <h4 class="text-center">Customer Scan</h4>
                </div> 
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div>
                        <sumCustomer
                            :data="data.sumCustomer"
                            v-if='data.sumCustomer'
                        ></sumCustomer>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <!-- Customer Scan Table End -->

        <!-- Claim MD Table Start -->
        <div class="row">
            <div class="col-lg-2 offset-lg-10 col-md-4 offset-md-8 col-12">
                <MultiSelect 
                    v-model="filter.sumClaimMD.year"
                    :options="options.year"
                    :deselect-label="''"
                    :allowEmpty="false"
                    placeholder="All Years"
                    class="elegant-multiselect"
                />
            </div>
        </div>
        <div class="bg-white shadow box-content mt-3 mb-5">
            <div class="row">
                <div class="col-md-12">
                    <h4 class="text-center">Claim Main Dealer</h4>
                </div> 
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div>
                        <sumClaimMD
                            :data="data.sumClaimMD"
                            v-if='data.sumClaimMD'
                        ></sumClaimMD>
                    </div>
                </div>
            </div>
        </div>
        <!-- Claim MD Table End -->
        

    </div>
</template>

<script>
    // import reportByPo from './children/SumLabelMaker'
    // import sumLabelMenara from './children/SumLabelMakerMenara'
    import sumLabelCahaya from './children/SumLabelMakerCahaya'
    import sumCustomer from './children/SumCustomerScan'
    import sumClaimMD from './children/SumClaimMD'
    import qs from 'qs'
    import sumOilMaker from './children/SumOilMaker'
    import moment from 'moment'

    export default {
        metaInfo : {
            title : 'Summary Report'
        },
        components : {
            // sumLabelMenara,
            sumLabelCahaya,
            sumCustomer,
            sumClaimMD,
            sumOilMaker
        },
        data () {
            let year = new moment().format("YYYY");

            return {
                minimumYear : 2022,
                currentYear : year,
                data : {
                    sumLabelCahaya : null,
                    sumCustomer : null,
                    sumClaimMD : null,
                    sumOilMaker : null,
                },
                options : {
                    year : [],
                },
                filter : {
                    sumLabelCahaya : {year : year},
                    sumCustomer : {year : year},
                    sumClaimMD : {year : year},
                    sumOilMaker : {year : year},
                    pagination : false
                }
                
            }
        },
        mounted () {
            this.fetchAllData();
            this.generateYearOptions();
        },
        watch : {
            "filter.sumLabelCahaya" : {
                deep:true,
                handler:'fetchSumLabelCahaya'
            },
            "filter.sumCustomer" : {
                deep:true,
                handler:'fetchSumCustomer'
            },
            "filter.sumClaimMD" : {
                deep:true,
                handler:'fetchSumClaimMD'
            },
            "filter.sumOilMaker" : {
                deep:true,
                handler:'fetchSumOilMaker'
            },
        },
        methods : {
            generateYearOptions () {
                let years = [];

                for (var year = parseInt(this.currentYear); year >= 2021; year--) years.push(year);

                this.options.year = years;
            },  
            fetchAllData () {
                this.fetchSumLabelCahaya();
                this.fetchSumCustomer();
                this.fetchSumOilMaker();
                this.fetchSumClaimMD();  
            },
            //Get Label Maker Cahaya Menara Summary
            fetchSumLabelCahaya () {
                this.data.sumLabelCahaya = null;
                this.$http.get(`/api/reports/summary-labelmaker?${qs.stringify(this.filter.sumLabelCahaya, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.sumLabelCahaya = resp.data.data;
                })
                .catch((err)=>{console.log(err)});
            },
            //Get Customer Summary
            fetchSumCustomer () {
                this.data.sumCustomer = null;
                this.$http.get(`/api/reports/summary-customer?${qs.stringify(this.filter.sumCustomer, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.sumCustomer = resp.data.data;
                })
                .catch((err)=>{console.log(err)});
            },
            //Get Oil Maker Summary
            fetchSumOilMaker () {
                this.data.sumOilMaker = null;
                this.$http.get(`/api/reports/summary-oilmaker?${qs.stringify(this.filter.sumClaimMD, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.sumOilMaker = resp.data.data;
                })
                .catch((err)=>{console.log(err)});
            },
        
            //Get MD Claim
            fetchSumClaimMD () {
                this.data.sumClaimMD = null;
                this.$http.get(`/api/reports/summary-maindealer?${qs.stringify(this.filter.sumOilMaker, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.sumClaimMD = resp.data.data;
                })
                .catch((err)=>{console.log(err)});
            },
        }
    }
</script>

<style scoped>
.innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .table td, .table th{
        text-align: center;
    }

    .box-content {
        padding: 20px;
        border-radius: 10px;
    }
</style>